import React, { Component } from 'react';
import ReactJWPlayer from 'react-jw-player';


class VideoPlayer extends Component {
    
    constructor(props){
        super(props);    
    }
    
    render() {
        return (
            <div>
                <ReactJWPlayer
                    playerId={this.props.playerId}
                    licenseKey={this.props.config.licenseKey}
                    playerScript={this.props.config.hostedJwPlayerScript}
                    playlist={this.props.tracks.playlist}
                    customProps={this.props.config.playerConfig}
                />
            </div>
        );
    }
}

export default VideoPlayer;